import connect from '../axios/axios.auth';

const licenciaFunction =  {
  data: () => {
    return new Promise((resolve) => {
      connect.get(`/empresa/licencia`)
      .then((response) => {
        resolve(response.data)
      })
    })
  },
  pago: (data) => {
    return new Promise((resolve) => {
      connect.post(`/empresa/pagos`, data)
      .then((response) => {
        resolve(response.data)
      })
    })
  },
  webpay: (data) => {
    return new Promise((resolve) => {
      connect.post(`/licencia/pagos`, data)
      .then((response) => {
        resolve(response.data)
      })
    })
  }
}

export default licenciaFunction;